import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { UsersService } from '../../../shared/services/users.service';
import { AuthService } from '../../../core/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  public isLoggedIn: any = false;
  public user: any = {
    profile_photo: 'assets/images/common/no-user-img.svg'
  };

  constructor(
    private _users: UsersService,
    private auth: AuthService
  ) { }

  ngOnInit() {

    firebase.auth().onAuthStateChanged((user) => {
     if (user) {
       this.user.uid = user.uid;
       this.isLoggedIn = true;
       // Get the user profile photo
       this._users.getCurrentUserProfileImage(user.uid).subscribe(data => {
         if(data.$value !== null) {
           this.user.profile_photo = data.$value;
         }
       });
     } else {
       this.isLoggedIn = false;
     }
    });
  }


  signout() {
    this.auth.signOut();
  }
}
